/* eslint-disable no-lone-blocks */
// import OwlCarousel from "react-owl-carousel-autoheight";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";
import { addDays, format } from "date-fns";
import { useState } from "react";
import { CONTACT_AGENT_URL } from "../../Global/API's";
import LoadingView from "../Loader";

let dateArr = [];
const date = new Date();
for (let i = 0; i < 9; i++) {
  const tomorrow = addDays(date, i);
  const dateObj = {
    month: format(tomorrow, "MMM"),
    dayOfWeek: format(tomorrow, "iiii"),
    date: format(tomorrow, "dd"),
    year: format(tomorrow, "y"),
  };
  dateArr = [...dateArr, dateObj];
}

const timeOptions = [
  {
    label: "Morning",
    time: "8AM - 12PM",
  },
  { label: "Afternoon", time: "12PM - 5PM" },
  { label: "Evening", time: "5PM - 9PM" },
];

const DatesList = ({ eachDate, selectedDate, dateChange }) => {
  const dateFormmat =
    eachDate.month + " " + eachDate.date + ", " + eachDate.year;
  return (
    <div className="form-group">
      <input
        value={dateFormmat}
        type="radio"
        name="tour_date"
        onChange={dateChange}
        checked={dateFormmat === selectedDate}
      />
      <label>
        {eachDate.dayOfWeek.slice(0, 3)} <b>{eachDate.date}</b>{" "}
        {eachDate.month.slice(0, 3)}
      </label>
    </div>
  );
};

const ContactModal = ({ title, agentDetails, listingID, id }) => {
  const [isConfirm, setIsConfirm] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    dateArr[0].month + " " + dateArr[0].date + ", " + dateArr[0].year
  );
  const [selectedTime, setSelectedTime] = useState("8AM - 12PM");
  const [isSubmitted, seIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userDetails, setUserdetails] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const onConfimRequest = () => {
    setIsConfirm(true);
  };

  const onCloseBlock = () => {
    setTimeout(() => {
      setSelectedTime("8AM - 12PM");
      setSelectedDate(
        dateArr[0].month + " " + dateArr[0].date + ", " + dateArr[0].year
      );
      setIsConfirm(false);
      seIsSubmitted(false);
    }, 500);
  };

  const timeChange = (e) => {
    setSelectedTime(e.target.value);
  };

  const dateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const onHandleChane = (e) => {
    const { name, value } = e.target;
    setUserdetails({ ...userDetails, [name]: value });
  };

  const renderFormView = () => (
    <>
      {id === "request-btn" && (
        <>
          <p>
            You are requesting a tour on
            <strong style={{ fontWeight: 600 }}> {selectedDate},</strong> as
            soon as possible.
          </p>
          <input name="tour_date" type="hidden" value={selectedDate} />
          <input name="tour_time" type="hidden" value={selectedTime} />
        </>
      )}
      {agentDetails?.data && (
        <input name="agent_id" type="hidden" value={agentDetails.data.userID} />
      )}
      {listingID && <input name="listing_id" type="hidden" value={listingID} />}
      <input name="type" type="hidden" value={id === "request-btn" ? 3 : 1} />
      {["name", "email", "phone"].map((field) => (
        <div className="form-group" key={field}>
          <label className="req-label">
            {field.charAt(0).toUpperCase() + field.slice(1)}
          </label>
          <input
            required
            name={field}
            className="form-control"
            type={field === "email" ? "email" : "text"}
            onChange={onHandleChane}
            value={userDetails[field]}
          />
        </div>
      ))}
      <div className="form-group">
        <label>Message</label>
        <textarea
          className="form-control"
          name="message"
          onChange={onHandleChane}
          value={userDetails.message}
        />
      </div>
    </>
  );

  const renderReuqestTourview = () => (
    <>
      <p>
        A licensed real estate professional from EXR will reach out regarding
        your tour request.
      </p>
      <strong>
        <em>• DATE</em>
      </strong>
      <div className="date-container">
        {dateArr.map((eachDate, i) => (
          <DatesList
            selectedDate={selectedDate}
            dateChange={dateChange}
            eachDate={eachDate}
            key={i}
          />
        ))}
      </div>
      {/* <OwlCarousel
                  className="owl-carousel calendar-list-carousel"
                  nav={true}
                  dots={false}
                  margin={16}
                  items={5}
                  responsive={{
                    0: {
                      items: 4,
                    },
                    376: {
                      items: 5,
                      margin: 10,
                    },
                    480: {
                      items: 5,
                      margin: 16,
                    },
                  }}
                >                  
                </OwlCarousel> */}
      <strong>
        <em>• TIME</em>
      </strong>
      <ul className="time-list">
        {timeOptions.map(({ label, time }, i) => (
          <li className="form-group" key={i}>
            <input
              type="radio"
              name="tour_time"
              checked={selectedTime === time}
              value={time}
              onChange={timeChange}
            />
            <label>
              {label} <b>{time}</b>
            </label>
          </li>
        ))}
      </ul>
      <strong>
        <em>• Remote Tour</em>
      </strong>
      <p>
        Tour this listing remotely through Face time, Google, Hangout, What app
        or Skype.
      </p>
    </>
  );

  const onContactAgentSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const { id } = e.target;
    const { name, email, phone, message } = userDetails;
    try {
      const formValues = {
        agent_id: agentDetails?.data?.userID,
        listing_id: listingID,
        type: id === "requestATourForm" ? 3 : 1,
        tour_date: id === "requestATourForm" ? selectedDate : null,
        tour_time: id === "requestATourForm" ? selectedTime : null,
        name,
        email,
        phone,
        message,
      };
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });
      const response = await fetch(CONTACT_AGENT_URL, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if ((data.status = "Success")) {
        seIsSubmitted(true);
      }
      console.log(data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const renderConfirmMessageView = () => (
    <div className="modal-body confirm-message-body">
      <img src="/assets/images/request-icon.png" alt="" />
      <h4>Thank you for your inquiry.</h4>
      <p>An agent will be contact with you.</p>
      <button
        type="button"
        className="btn"
        data-bs-dismiss="modal"
        aria-label="Close"
        onClick={onCloseBlock}
      >
        Return to listing
      </button>
    </div>
  );

  const renderLoadingView = () => <LoadingView />;

  return (
    <div
      className="modal fade modal-block request-block-modal"
      id={id}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <form
        id={id === "request-btn" ? "requestATourForm" : "contactAgent"}
        onSubmit={onContactAgentSubmit}
      >
        <div className="modal-dialog" role="document">
          <div
            className={
              isConfirm || id === "contact-btn"
                ? "modal-content confirm-block-content"
                : "modal-content request-block"
            }
          >
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={onCloseBlock}
              >
                <svg
                  viewBox="0 0 32 32"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                  className="Icon-c11n-8-100-2__sc-13llmml-0 fBvdWz"
                >
                  <path
                    stroke="none"
                    d="M18.83,16,29.41,5.41a2,2,0,0,0-2.82-2.82L16,13.17,5.41,2.59A2,2,0,0,0,2.59,5.41L13.17,16,2.59,26.59a2,2,0,1,0,2.82,2.82L16,18.83,26.59,29.41a2,2,0,0,0,2.82-2.82Z"
                  ></path>
                </svg>
              </button>
              <h5>{isConfirm ? "Confirm Your Tour" : title}</h5>
            </div>
            {isSubmitted ? (
              renderConfirmMessageView()
            ) : (
              <div className="modal-body">
                {isConfirm || id === "contact-btn"
                  ? renderFormView()
                  : renderReuqestTourview()}
              </div>
            )}
            {!isSubmitted && (
              <div className="modal-footer">
                {id === "request-btn" ? (
                  <button
                    type={isConfirm ? "submit" : "button"}
                    onClick={isConfirm ? undefined : onConfimRequest}
                    className="btn"
                  >
                    {isConfirm ? "Confirm Your Tour" : "Continue"}
                  </button>
                ) : (
                  <button type="submit" className="btn">
                    Contact agent
                  </button>
                )}
              </div>
            )}
          </div>
          {isLoading && renderLoadingView()}
        </div>
      </form>
    </div>
  );
};

export default ContactModal;
